// System / plumbing metadata keys that are surfaced through dedicated UI (or
// are internal render/persistence bookkeeping) and must never appear as raw,
// user-editable fields in the clip Settings modal. Centralized here so the
// Settings editor and any future consumer share one authoritative list.

export const SYSTEM_METADATA_KEYS = new Set<string>([
  'last_reference_image_url',
  // Its companion id, stamped in lockstep by internal/pipeline/assembly.go and
  // surfaced through the same dedicated UI (the reference-frames editor). Hidden
  // for the same reason the URL is: editing half of a bound pair by hand makes
  // the id and the URL name two different stills.
  'last_reference_media_id',
  'subtitle_text',
  'music_url',
  'branding_tag',
  'brandingtag',
  'headline',
  'actiontext',
  'calltoaction',
  'stylepresetid',
  'stylepresetname',
  'stylepresetdirty',
  'stylepresetdraft',
  // Render bookkeeping (models/prompt.go) — never user-editable.
  'render_status',
  'render_progress',
  'render_error',
  // EU AI label — surfaced through the editor's dedicated controls.
  'ai_label',
  'ai_label_icon',
  'ai_label_style',
  'ai_label_position',
  // The carousel's on-screen AI tag (label, text, size, corner, slides) — an engine key, set from
  // the agent tools panel or by the assistant, never hand-edited as a raw field.
  'ai_tag',
  // Backend-aggregated provenance summary for the mp4 file tags.
  'ai_models',
]);
